import { useSearchParams } from "react-router-dom";
import { useDocumentShowQuery } from "@/admin/entities/documents";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

/**
 * Feature-специфичные хуки для управления документами
 * Комбинируют entity-логику с UI-специфичными потребностями
 */

/**
 * Основной хук для feature управления документами
 * Предоставляет всю необходимую конфигурацию и логику для UI компонента
 */
export function useDocumentsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // Используем entity хук для загрузки данных документа
  useDocumentShowQuery(id, id === null);

  return {
    // Конфигурация таблицы
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,

    // Трансформация данных
    getTableData,

    // Текстовые метки
    texts: getTextsConfig(),
  };
}
